import React from 'react';
import { FormattedMessage } from 'react-intl';
import PositiveToast from '@/components/toasts/PositiveToast';
import SharedToast from './SharedToast';

const SharesToast = ({ name, members }) => {
  if (members.length === 1) {
    return (<SharedToast name={name} />);
  }

  return (
    <PositiveToast className="aridhia-shares-toast" icon="share alternate">
      <FormattedMessage id="toast.shares" values={{ name, count: members.length }} />
    </PositiveToast>
  );
};

export default SharesToast;
